/**
 * GrantCreditsModal - Modal for granting credits to a user
 */
export default function GrantCreditsModal({
  show,
  onClose,
  grantAmount,
  setGrantAmount,
  grantReason,
  setGrantReason,
  onGrant,
  loading,
  isBulk = false,
  selectedCount = 0,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-xl max-w-md w-full p-6 space-y-4">
        <h3 className="text-xl font-bold text-foreground">
          {isBulk ? `Grant Credits to ${selectedCount} Users` : "Grant Credits"}
        </h3>
        <input
          type="number"
          placeholder={isBulk ? "Amount per user" : "Amount"}
          value={grantAmount}
          onChange={(e) => setGrantAmount(e.target.value)}
          className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="text"
          placeholder="Reason"
          value={grantReason}
          onChange={(e) => setGrantReason(e.target.value)}
          className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {isBulk && (
          <div className="bg-primary/10 border border-teal-500/20 rounded-lg p-3">
            <p className="text-teal-400 text-sm">
              Each user will receive <strong>{grantAmount || 0}</strong> credits
            </p>
          </div>
        )}
        <div className="flex gap-3">
          <button
            onClick={onGrant}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 text-foreground rounded-lg transition"
          >
            {loading ? "Processing..." : isBulk ? "Grant to All" : "Grant"}
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-muted hover:bg-slate-600 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
